import { Search } from "lucide-react";
import { useLanguage } from "@/lib/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="relative z-10 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-yellow-400 to-amber-500 flex items-center justify-center">
              <Search className="w-4 h-4 text-black" />
            </div>
            <span className="font-bold tracking-tight text-white" style={{ fontFamily: 'Inter, sans-serif' }}>
              {t("header.brand")}
            </span>
          </div>
          <p className="text-sm text-white/30">
            {t("footer.powered")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
